import { render, staticRenderFns } from "./BuscarClientes.vue?vue&type=template&id=8e685b22&scoped=true"
import script from "./BuscarClientes.vue?vue&type=script&lang=js"
export * from "./BuscarClientes.vue?vue&type=script&lang=js"
import style0 from "./BuscarClientes.vue?vue&type=style&index=0&id=8e685b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e685b22",
  null
  
)

export default component.exports